import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';

import {getUserName, isAssessor} from '../../reducers/user';
import {completeTutorial} from '../../actions/testroom';
import {setCurrentTest, loadTests} from '../../actions/tests';
import {getTests, getCurrentTest, getCompletedTest} from '../../reducers/tests';
import {getUserCampaign, getCampaignLang} from '../../reducers/userCampaign';
import {getIsMobile} from '../../reducers/ui';

import TestsList from '../../components/TestsList';
import StartTest from '../StartTest';
import TestIntro from '../../components/TestIntro';

import {TEST_START, TESTS, HOME} from '../../services/routes';

import s from './TestRoom.css';

class TestRoom extends Component {
  mainRef = React.createRef();

  componentDidMount() {
    this.props.loadTests();
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = event => {
    //if test-intro is shown
    if ((event.key === 'Escape' || event.key === "Esc") && this.props.currentTest) {
      this.unsetCurrentTest();
    }
  };

  completeTutorial = () => {
    this.props.completeTutorial();
  };

  setCurrentTest = item => {
    this.props.setCurrentTest(item);
  };

  unsetCurrentTest = () => this.setCurrentTest(null);

  goToDetails = () => {
    this.props.push(TEST_START);
  };

  render() {
    const {
      leftComponent: LeftComponent,
      currentTest,
      testsList,
      completedTests,
      userCampaign,
      lang,
      isAssessor,
      isMobile
    } = this.props;

    if (isMobile) {
      return (
        <div className={s.TestRoom} ref={this.mainRef}>
          <Switch>
            <Route path={HOME} exact>
              <LeftComponent
                {...this.props}
                completeTutorial={this.completeTutorial}
                testsList={testsList}
                userCampaign={userCampaign}
              />
            </Route>
            <Route path={TESTS}>
              <TestsList
                goToDetails={this.goToDetails}
                isMobile={isMobile}
                userCampaign={userCampaign}
                setCurrentTest={this.setCurrentTest}
                currentTest={currentTest}
                testsList={testsList}
                completedTests={completedTests}
                lang={lang}
                isAssessor={isAssessor}
              />
            </Route>
            <Route path={TEST_START}>
              <StartTest />
            </Route>
          </Switch>
        </div>
      );
    }

    return (
      <div
        ref={this.mainRef}
        className={s.TestRoom}
        onMouseLeave={this.unsetCurrentTest}
        aria-live="assertive"
      >
        <div className={s.LeftColumn}>
          {currentTest && currentTest.size > 0 ? (
            <TestIntro
              currentTest={currentTest}
              goToDetails={this.goToDetails}
              lang={lang}
            />
          ) : (
            <LeftComponent
              {...this.props}
              completeTutorial={this.completeTutorial}
              testsList={testsList}
              userCampaign={userCampaign}
            />
          )}
        </div>
        <div className={s.RightColumn}>
          <TestsList
            userCampaign={userCampaign}
            setCurrentTest={this.setCurrentTest}
            currentTest={currentTest}
            testsList={testsList}
            completedTests={completedTests}
            lang={lang}
            isAssessor={isAssessor}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const userName = getUserName(state);
  const currentTest = getCurrentTest(state);
  const testsList = getTests(state);
  const completedTests = getCompletedTest(state);
  const userCampaign = getUserCampaign(state);
  const lang = getCampaignLang(state);
  const isMobile = getIsMobile(state);

  return {
    userName,
    currentTest,
    testsList,
    completedTests,
    userCampaign,
    lang,
    isMobile,
    isAssessor: isAssessor(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {completeTutorial, setCurrentTest, loadTests, push},
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TestRoom);
